import {
  getBackendErrorCode,
  getBackendErrorEvidence
} from '../../server/helper'

export const DEFAULT_404_ERROR_SHORTCODE = '#defaultMessage'

export const ERROR_HANDLER = {
  OPEN_SIGN_IN_WINDOW: 'OPEN_SIGN_IN_WINDOW'
}
/*
 * names of HTTP response status codes/names were taken from this link
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
 * */

export const HTTP_STATUS_CODE = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  GONE: 410,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503
}

export const ERROR_MESSAGE = {
  PAGE_NOT_FOUND:
    "404 Error. It could be an outdated link or just a small technical glitch. Try the URL again, or find what you're looking for on our <a href='/'>Homepage</a>.",
  DEFAULT_SERVER_ERROR:
    'The server is experiencing an outage, either planned or unplanned'
}

export const ERROR_TITLE = {
  PAGE_NOT_FOUND: 'page not found'
}

/**
 * In case of redirecting user to error page we always show 404 status
 * and message "Page not found" (requested by client)
 * Commented message and status are real mapping (could be used later)
 */
const DEFAULT_INFO_SETTINGS = {
  title: ERROR_TITLE.PAGE_NOT_FOUND,
  message: ERROR_MESSAGE.PAGE_NOT_FOUND,
  status: HTTP_STATUS_CODE.NOT_FOUND
}

const HTTP_STATUS_INFO_SETTINGS = {
  [HTTP_STATUS_CODE.BAD_REQUEST]: {
    // title: 'Service unavailable',
    // message: ERROR_MESSAGE.DEFAULT_SERVER_ERROR,
    // status: HTTP_STATUS_CODE.SERVICE_UNAVAILABLE
    ...DEFAULT_INFO_SETTINGS
  },
  [HTTP_STATUS_CODE.FORBIDDEN]: {
    // title: 'Forbidden',
    // message: 'You do not have access to this page',
    // status: HTTP_STATUS_CODE.FORBIDDEN
    ...DEFAULT_INFO_SETTINGS
  },
  [HTTP_STATUS_CODE.NOT_FOUND]: {
    // title: ERROR_MESSAGE.PAGE_NOT_FOUND,
    // message:
    //   "404 Error. It could be an outdated link or just a small technical glitch. Try the URL again, or find what you're looking for on our <a href='/'>Homepage</a>.",
    // status: HTTP_STATUS_CODE.NOT_FOUND
    ...DEFAULT_INFO_SETTINGS
  },
  [HTTP_STATUS_CODE.METHOD_NOT_ALLOWED]: {
    // title: ERROR_MESSAGE.PAGE_NOT_FOUND,
    // message:
    //   "405 Error. It could be an outdated link or just a small technical glitch. Try the URL again, or find what you're looking for on our <a href='/'>Homepage</a>.",
    // status: HTTP_STATUS_CODE.METHOD_NOT_ALLOWED
    ...DEFAULT_INFO_SETTINGS
  },
  [HTTP_STATUS_CODE.GONE]: {
    title: 'Page deleted or gone',
    message:
      'The page you are looking for may have been deleted, please visit our <a href="/">homepage</a> for the latest info.',
    status: HTTP_STATUS_CODE.GONE
  },
  [HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR]: {
    // title: 'Internal Server Error',
    // message: ERROR_MESSAGE.DEFAULT_SERVER_ERROR,
    // status: HTTP_STATUS_CODE.SERVICE_UNAVAILABLE
    ...DEFAULT_INFO_SETTINGS
  },
  [HTTP_STATUS_CODE.SERVICE_UNAVAILABLE]: {
    // title: 'Internal Server Error',
    // message: ERROR_MESSAGE.DEFAULT_SERVER_ERROR,
    // status: HTTP_STATUS_CODE.SERVICE_UNAVAILABLE
    ...DEFAULT_INFO_SETTINGS
  }
}

const DEFAULT_ERROR_SETTINGS = {
  status: 404,
  showErrorPage: false,
  showMessage: true,
  skipLogging: false
}

export const ERROR_CODE = {
  USER_NOT_FOUND: 'UserNotFound', // => USER_NOT_FOUND
  INTERNAL_SERVER_ERROR: 'InternalServerError'
}

export const ERROR_CODE_V2 = {
  USER_NOT_FOUND: 'fm.identity.00103'
}

export const ERROR_CODE_INFO_SETTINGS_V2 = {
  [ERROR_CODE_V2.USER_NOT_FOUND]: {
    ...DEFAULT_ERROR_SETTINGS,
    code: ERROR_CODE_V2.USER_NOT_FOUND,
    title: ERROR_MESSAGE.PAGE_NOT_FOUND,
    status: 404,
    getMessage: () => `We could not find this account in our system.
        Please #{sign-up}{${ERROR_HANDLER.OPEN_SIGN_IN_WINDOW}}# for an account`,
    showMessage: false
  }
}

const ERROR_CODE_INFO_SETTINGS = {
  [ERROR_CODE.USER_NOT_FOUND]: {
    ...DEFAULT_ERROR_SETTINGS,
    code: ERROR_CODE.USER_NOT_FOUND,
    title: ERROR_MESSAGE.PAGE_NOT_FOUND,
    status: 404,
    message: `We could not find this account in our system.
        Please #{sign-up}{${ERROR_HANDLER.OPEN_SIGN_IN_WINDOW}}# for an account`,
    showMessage: false
  },
  [ERROR_CODE.INTERNAL_SERVER_ERROR]: {
    ...DEFAULT_ERROR_SETTINGS,
    code: ERROR_CODE.INTERNAL_SERVER_ERROR,
    title: ERROR_MESSAGE.DEFAULT_SERVER_ERROR,
    status: 404,
    message: 'page not found'
  }
}

export function getHttpStatusInfo(status) {
  return (
    HTTP_STATUS_INFO_SETTINGS[status] ||
    HTTP_STATUS_INFO_SETTINGS[HTTP_STATUS_CODE.BAD_REQUEST]
  )
}

export function getErrorSettingsByBackendError(error) {
  const code = getBackendErrorCode(error)
  const evidence = getBackendErrorEvidence(error)

  const errorInfo =
    ERROR_CODE_INFO_SETTINGS_V2[code] ||
    ERROR_CODE_INFO_SETTINGS[code] ||
    ERROR_CODE_INFO_SETTINGS[ERROR_CODE.INTERNAL_SERVER_ERROR]

  const message =
    'message' in errorInfo ? errorInfo.message : errorInfo.getMessage(evidence)

  const errorSettings = {
    ...errorInfo,
    message
  }

  return errorSettings
}
